module.exports = __webpack_public_path__ + "img/total.ae0e7241.svg";